import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import PropTypes from "prop-types";
import DataTable from "examples/Tables/DataTable";

import MDTypography from "components/MDTypography";
import { Currency } from "components/CustomCurrency/currency";
import { Unit } from "components/CustomUnits/units";

function getTableData(modalData, dataType) {
  // param: modalData = [
  //   {
  //     "company": "ZOETIS",
  //     "sale": 609588.30,
  //     "product": "SIMPARICA"
  // }
  // ]
  let totales = 0;
  modalData.forEach((element) => {
    totales += Number(element.sale);
  });

  return {
    columns: [
      {
        Header: (
          <>
            <div>Empresa</div>
            <div>
              <MDTypography variant="inherit"> &nbsp;</MDTypography>
            </div>
          </>
        ),
        accessor: "company",
      },
      {
        Header: (
          <>
            <div>Producto</div>
            <div>
              <MDTypography variant="inherit">Totales</MDTypography>
            </div>
          </>
        ),
        accessor: "product",
      },
      {
        Header: (
          <>
            <div>Ventas</div>
            <div>
              <MDTypography variant="inherit">
                {dataType === "unidades" ? (
                  <Unit value={totales}></Unit>
                ) : (
                  <Currency value={totales}></Currency>
                )}
              </MDTypography>
            </div>
          </>
        ),
        accessor: "sales",
      },
    ],
    rows: modalData.map((elem) => {
      return {
        company: elem.company,
        product: elem.product,
        sales:
          dataType === "unidades" ? (
            <Unit value={elem.sale}></Unit>
          ) : (
            <Currency value={elem.sale}></Currency>
          ),
      };
    }),
  };
}

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export default function DetailsDialog({ open, setOpen, modalData, dataType }) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          style={{ cursor: "move", backgroundColor: "whitesmoke" }}
          id="draggable-dialog-title"
        >
          Detalles Empresa
        </DialogTitle>
        <DialogContent>
          <DataTable table={getTableData(modalData, dataType)} canSearch={true} />
        </DialogContent>
        <DialogActions style={{ cursor: "move", backgroundColor: "whitesmoke" }}>
          <Button autoFocus onClick={handleClose}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

DetailsDialog.defaultProps = {
  open: false,
  setOpen: null,
  modalData: [],
  dataType: "unidades",
};

DetailsDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  modalData: PropTypes.array,
  dataType: PropTypes.string,
};
